import "./App.css";
import Routes from "./routes/Routes";
import "./assets/css/style.css";
function App() {
  return (
    <Routes />)
}

export default App;
